export const ZERO_DECIMAL_CURRENCIES = ['JPY'];
